export default __webpack_public_path__ + "static/Data-Analytics-347f6db341ff6b48dc1a9b3a20999b73.webp";